/**
 * Canvas renderer for the icon widget: the same primitive the published page
 * renders, so the canvas is the page. It has no text to type into on the
 * canvas — its props are edited in Settings (ADR-0010 allows a widget without
 * slots).
 */
import type { WidgetProps } from "@website-builder/editor";

import { PrimitiveIcon, type IconContent } from "./primitives.js";

export function DuroIconWidget({ contentProps }: WidgetProps) {
  return <PrimitiveIcon {...((contentProps ?? {}) as IconContent)} />;
}
